import { useSuspenseQuery } from '@tanstack/react-query';

import { Id, useAppNotification } from '@feature/utils';
import { ValidationRequest, ValidationVariant } from '@feature/validation';
import { ValidationAction } from '@feature/validation/ValidationAction';

import {
  getResearchPerfEvalItemValidationOptions,
  useValidateResearchPerfEvalItem,
} from './model/ResearchPerfEvalItemValidationModel';

interface ValidationActionProps {
  itemId: Id;
  variant?: ValidationVariant;
  onAfterValidation?: () => void;
}

export function ResearchPerfEvalItemValidationAction({ itemId, variant, onAfterValidation }: ValidationActionProps) {
  const { data } = useSuspenseQuery(getResearchPerfEvalItemValidationOptions(itemId));
  const notification = useAppNotification();
  const { mutate, isPending } = useValidateResearchPerfEvalItem(itemId);

  const onSubmit = (request: ValidationRequest) => {
    mutate(request, {
      onSuccess: () => {
        notification.success();
        if (onAfterValidation) {
          onAfterValidation();
        }
      },
      onError: notification.error,
    });
  };

  return (
    <ValidationAction
      validation={data}
      isPending={isPending}
      onSubmit={onSubmit}
      variant={variant}
    />
  );
}
